import PropTypes from 'prop-types';
import { createElement } from 'react';
import { twMerge } from 'tailwind-merge';

const TYPES = {
  UNORDERED: 'unordered',
  ORDERED: 'ordered',
  GHOST: 'ghost',
};

const ListGroup = ({ children, className, type = TYPES.UNORDERED, ...rest }) =>
  createElement(
    type === TYPES.ORDERED ? 'ol' : 'ul',
    {
      className: twMerge(
        'space-y-2',
        type === TYPES.GHOST && 'list-none',
        className
      ),
      ...rest,
    },
    <>{children}</>
  );

ListGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  type: PropTypes.oneOf(Object.values(TYPES)),
};

export default ListGroup;
